import React, { Component } from 'react';
import { useImage } from 'react-image'
import {imagePath} from '../common'
export function BannerComponent(props) {


    const { src } = useImage({
        srcList:imagePath+props.banner_image
    })
    return (
        <div className="newslatter-sec w-left" style={{ backgroundImage: 'url(' + src + ')', backgroundSize: 'cover', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat' }}>
            <div className="left-img-news">
                <div className="bg-left-news" >
                </div>
            </div>
            <div className="right-side-form">
                <div className="inner-right-side-f">
                    <h3 className="wthree_text_info">{props.banner_title}</h3>
                    <p>{props.banner_content}</p>
                    <form>
                        <input type="email" name="Email" placeholder="Email" value={props.email}  onChange={async (e) => {props.onChange(e)}}/>

                        <button type="submit" className="hvr-outline-out button2 sub-newlter" onClick={(e) => { props.onClick(e) }}  >{props.banner_button}</button>
                        <p className="Erro_msg">{props.emailerror}</p>
                    </form>
                </div>
            </div>
        </div>
    )
}

//onClick={(e) => { this.get_subscribe(e) }} disabled={this.state.email_loader} style={this.state.email_loader ? { "opacity": '0.4' } : {}}

//onChange={async (e) => {
//     {
//         await this.setState({ email: e.target.value, emailerror: "" }, async () => {
//             await this.updatebanner();
//         })
//     }
// }}